<div *ngIf="!mostrarMensajeConfirmacion">

    <div class="d-flex justify-content-center px-0 mx-0 mt-5">
        <div class="col col-lg-8">
            <div class="d-flex justify-content-between align-items-center bg-secondary text-white p-3">
                <label class="fs-5 m-0"><span class="vag-bold-font text-uppercase">Inscripción</span> Documentos</label>
                <button (click)="logout()" type="button" class="d-inline-flex btn btn-outline text-white">
                    <label class="d-none d-md-block mr-3 fs-5">Salir</label>
                    <fa-icon [icon]="powerOffIcon" size="lg" class="text-white"></fa-icon>
                </button>
            </div>
            <div class="menu-cabecera d-flex justify-content-center">
                <div class="col col-lg-8">
                    <img src="../../assets/img/step4.png" style="max-width: 100%;" alt="">
                </div>
            </div>
            <div class="mb-5">
                <div class="title_center mb-3">
                    <label class="fs-5">Mensaje <span class="vag-bold-font text-uppercase">WEB</span></label>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="d-none d-lg-flex col-lg-4">
                        <img src="../../assets/img/mascota.png" style="max-width: 80%;" alt="">
                    </div>
                    <div class="col-12 col-lg-8">
                        <h1>¡Gracias por la inscripción!</h1>
                        <span class="fs-2">Os esperamos en Playbots para el inicio del curso.</span>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end py-5">
                <button *ngIf="banderaMensajeWeb" class="btn btn-outline-secondary btn-lg"
                    (click)="logout()">Finalizar</button>
            </div>
        </div>
    </div>

</div>